import ObjectiveTypeBase from '__core/shared/model/finance/ObjectiveTypeBase';
import template from './productRequirements.template.html';

export default {
  template,
  bindings: {
    formName: '<',
    objectives: '<',
    workflow: '<',
    diversificationOpportunities: '<',
    contacts: '<',
    addresses: '<',
    documents: '<',
    outboundReferrers: '<',
    validationErrors: '<',
    ticketOwner: '<',
    ticket: '<',
    compliance: '<',
    idAli: '<',
    isTicketSettled: '<',
    showBidFlows: '<',
    onFinished: '&',
    onDiversificationFinished: '&',
    onDiversificationIntegrationFinished: '&'
  },
  controller: class controller {
    constructor(
      $rootScope,
      $mdUtil,
      helperService,
      OpportunityContextualType,
      diversificationOpportunityService,
      ImportantOption
    ) {
      'ngInject';

      const ctrl = this;
      ctrl.currentOrganization = $rootScope.CurrentOrganization;
      ctrl.currentCurrency = $rootScope.CurrentCurrency();
      ctrl.organizationCountry = '';
      ctrl.availableImportantOptionsOne = [];
      ctrl.availableImportantOptionsTwo = [];
      ctrl.availableObjectivePreferredDurationOptionsOne = [];
      ctrl.availableObjectivePreferredDurationOptionsTwo = [];
      ctrl.availablePaymentFrequencies = [];
      ctrl.availableObjectivePaymentPlanOptions = [];
      ctrl.availableHowImportantOptions = [];
      ctrl.availableFrequencyOptions = [];
      ctrl.availableTermInYears = [];
      ctrl.availableTermInMonths = [];
      ctrl.isReady = false;

      ctrl.initialize = () => {
        ctrl.organizationCountry = helperService.getOrganizationCountry();
        ctrl.objectives = ctrl.objectives || {};
        ctrl.workflow = ctrl.workflow || {};
        ctrl.diversificationOpportunities = ctrl.diversificationOpportunities || [];
        ctrl.contacts = ctrl.contacts || [];
        ctrl.addresses = ctrl.addresses || [];
        ctrl.documents = ctrl.documents || [];
        ctrl.outboundReferrers = ctrl.outboundReferrers || [];
        ctrl.validationErrors = ctrl.validationErrors || [];
        ctrl.ticketOwner = ctrl.ticketOwner || {};
        ctrl.ticket = ctrl.ticket || {};
        ctrl.compliance = ctrl.compliance || {};
        ctrl.idAli = ctrl.idAli || '';
        ctrl.isTicketSettled = ctrl.isTicketSettled || false;
        ctrl.showBidFlows = ctrl.showBidFlows || false;
        ctrl.availableImportantOptionsOne = helperService.getAvailableImportantOptions({
          option: 1
        });
        ctrl.availableImportantOptionsTwo = helperService.getAvailableImportantOptions({
          option: 2
        });
        ctrl.availableObjectivePreferredDurationOptionsOne =
          helperService.getAvailableObjectivePreferredDurationOptions({ option: 1 });
        ctrl.availableObjectivePreferredDurationOptionsTwo =
          helperService.getAvailableObjectivePreferredDurationOptions({ option: 2 });
        ctrl.availablePaymentFrequencies = helperService.getAvailablePaymentFrequencies({
          workflow: ctrl.workflow
        });
        ctrl.availableObjectivePaymentPlanOptions =
          helperService.getAvailableObjectivePaymentPlanOptions();
        ctrl.availableHowImportantOptions = helperService.getAvailableHowImportantOptions();
        ctrl.availableFrequencyOptions = helperService.getAvailableFrequencyOptions();
        ctrl.availableTermInYears = helperService.getAvailableTermInYears({ isRegular: true });
        ctrl.availableTermInMonths = helperService.getAvailableTermInMonths({
          isRegular: true
        });
        ctrl.setProductRequirementsErrors();
        ctrl.setAvailableImportantOptions();
        ctrl.setDiversificationOpportunities();
        ctrl.isReady = true;
      };

      ctrl.setProductRequirementsErrors = () => {
        ctrl.productRequirementsErrors = _.filter(
          ctrl.validationErrors,
          (v) => v?.message?.toLowerCase()?.indexOf('product requirements -') > -1
        );
      };

      ctrl.toggleProductOptions = ({ type }) => {
        switch (type) {
          case 'fixed':
          case 'variable':
          case 'fixedAndVariable':
            if (
              ctrl.objectives?.rateType[type]?.type?.name ===
                ImportantOption.not_important.name ||
              ctrl.objectives?.rateType[type]?.type?.name === ImportantOption.do_not_want.name
            ) {
              ctrl.objectives.rateType[type] = new ObjectiveTypeBase({
                type: ctrl.objectives?.rateType[type]?.type || ImportantOption.none
              });
            }
            break;
          case 'principalAndInterest':
          case 'interestOnly':
          case 'interestInAdvance':
          case 'lineOfCredit':
            if (
              ctrl.objectives?.repaymentType[type]?.type?.name ===
                ImportantOption.not_important.name ||
              ctrl.objectives?.repaymentType[type]?.type?.name ===
                ImportantOption.do_not_want.name
            ) {
              ctrl.objectives.repaymentType[type] = new ObjectiveTypeBase({
                type: ctrl.objectives?.repaymentType[type]?.type || ImportantOption.none
              });
            }
            break;
          case 'offsetAccount':
          case 'redraw':
            if (
              ctrl.objectives?.productType[type]?.type?.name ===
                ImportantOption.not_important.name ||
              ctrl.objectives?.productType[type]?.type?.name ===
                ImportantOption.do_not_want.name
            ) {
              ctrl.objectives.productType[type] = new ObjectiveTypeBase({
                type: ctrl.objectives?.productType[type]?.type || ImportantOption.none
              });
            }
            break;
          default:
            break;
        }
        ctrl.saveProductRequirements();
      };

      ctrl.setAvailableImportantOptions = () => {
        if (
          ctrl.objectives?.whatIsImportantForYou?.lowestOverallLoanCost?.name ===
            ImportantOption.most_important.name ||
          ctrl.objectives?.whatIsImportantForYou?.loanApprovedQuickly?.name ===
            ImportantOption.most_important.name ||
          ctrl.objectives?.whatIsImportantForYou?.specificLoanFeatures?.name ===
            ImportantOption.most_important.name ||
          ctrl.objectives?.whatIsImportantForYou?.lenderPolicy?.name ===
            ImportantOption.most_important.name
        ) {
          ctrl.availableImportantOptionsTwo[0].isDisabled = true;
        }
      };

      ctrl.setDiversificationOpportunities = () => {
        if (ctrl.objectives.additionalServices.investmentSuperannuationAndFinancialPlanning) {
          ctrl.objectiveAdditionalPlanning =
            OpportunityContextualType.objective_additional_planning;
        } else {
          const idxPlanning =
            diversificationOpportunityService.getIndexOfContextualTypeInDiversificationOpportunities(
              {
                diversificationOpportunities: ctrl.diversificationOpportunities,
                typeContextual: OpportunityContextualType.objective_additional_planning
              }
            );
          if (idxPlanning > -1) {
            ctrl.diversificationOpportunities.splice(idxPlanning, 1);
          }
        }

        if (ctrl.objectives.additionalServices.propertyBuyingAdvocacy) {
          ctrl.objectiveAdditionalPropertyAdvocacy =
            OpportunityContextualType.objective_additional_property_advocacy;
        } else {
          const idxAdvocacy =
            diversificationOpportunityService.getIndexOfContextualTypeInDiversificationOpportunities(
              {
                diversificationOpportunities: ctrl.diversificationOpportunities,
                typeContextual: OpportunityContextualType.objective_additional_property_advocacy
              }
            );
          if (idxAdvocacy > -1) {
            ctrl.diversificationOpportunities.splice(idxAdvocacy, 1);
          }
        }

        if (ctrl.objectives.additionalServices.propertyInvestment) {
          ctrl.objectiveAdditionalInvestment =
            OpportunityContextualType.objective_additional_investment;
        } else {
          const idxInvestment =
            diversificationOpportunityService.getIndexOfContextualTypeInDiversificationOpportunities(
              {
                diversificationOpportunities: ctrl.diversificationOpportunities,
                typeContextual: OpportunityContextualType.objective_additional_investment
              }
            );
          if (idxInvestment > -1) {
            ctrl.diversificationOpportunities.splice(idxInvestment, 1);
          }
        }

        if (ctrl.objectives.additionalServices.healthCover) {
          ctrl.objectiveAdditionalHealth =
            OpportunityContextualType.objective_additional_health;
        } else {
          const idxHealth =
            diversificationOpportunityService.getIndexOfContextualTypeInDiversificationOpportunities(
              {
                diversificationOpportunities: ctrl.diversificationOpportunities,
                typeContextual: OpportunityContextualType.objective_additional_health
              }
            );
          if (idxHealth > -1) {
            ctrl.diversificationOpportunities.splice(idxHealth, 1);
          }
        }
        ctrl.saveDiversificationOpportunities(ctrl.diversificationOpportunities);
      };

      ctrl.hasValidationError = ({ path }) =>
        helperService.hasValidationError({ errors: ctrl.productRequirementsErrors, path });

      ctrl.changeWhatIsImportantForYou = ({ option, property }) => {
        if (
          option?.name === ImportantOption.most_important.name &&
          !ctrl.availableImportantOptionsTwo[0]?.isDisabled
        ) {
          ctrl.availableImportantOptionsTwo[0].isDisabled = true;
          ctrl.saveProductRequirements();
        } else {
          if (
            ctrl.objectives?.whatIsImportantForYou?.lowestOverallLoanCost?.name !==
              ImportantOption.most_important.name &&
            ctrl.objectives?.whatIsImportantForYou?.loanApprovedQuickly?.name !==
              ImportantOption.most_important.name &&
            ctrl.objectives?.whatIsImportantForYou?.specificLoanFeatures?.name !==
              ImportantOption.most_important.name &&
            ctrl.objectives?.whatIsImportantForYou?.lenderPolicy?.name !==
              ImportantOption.most_important.name
          ) {
            ctrl.availableImportantOptionsTwo[0].isDisabled = false;
          }
          if (
            ctrl.objectives?.whatIsImportantForYou[property]?.name !==
            ImportantOption.most_important.name
          ) {
            ctrl.objectives.whatIsImportantForYou[`${property}Comments`] = '';
          }
          ctrl.saveProductRequirements();
        }
      };

      ctrl.saveProductRequirements = () => {
        ctrl.setDiversificationOpportunities();
        ctrl.onFinished({ objectives: ctrl.objectives });
      };

      ctrl.saveDiversificationOpportunities = (diversificationOpportunities) => {
        if (ctrl.isReady === true) {
          ctrl.onDiversificationFinished({ diversificationOpportunities });
        }
      };

      ctrl.saveDiversificationIntegration = (integration, result) => {
        if (ctrl.isReady === true) {
          ctrl.onDiversificationIntegrationFinished({ integration, result });
        }
      };

      ctrl.$onInit = () => {
        ctrl.initialize();
      };

      ctrl.$onChanges = (changes) => {
        if (changes?.validationErrors?.currentValue) {
          ctrl.setProductRequirementsErrors();
        }
      };
    }
  }
};
